import React from 'react';
import { BoolToString } from 'components';
import { getTableColumns } from 'helpers';

const PartColumns = [
  ['participantGroup', 'string', 'Participant Group', 'left', true],
  ['roleType', 'string', 'Role Type', 'left', true],
  ['participationType', 'string', 'Participation Type', 'left', true],
  ['startDate', 'date', 'Start Date', 'center', true],
  ['endDate', 'date', 'End Date', 'center', true],
  ['dataSource', 'string', 'Data Source', 'left', true]
];

const orgTypeChangeObj = {
  ITN: 'SITE',
  CCC: 'CSRN'
}

const ParticipationColumns = [
  {
    name: 'orgType',
    type: 'string',
    label: 'Organization Type',
    filterable: true,
    renderCell: data => (data.orgType === 'ITN'  || data.orgType === 'CCC' ? orgTypeChangeObj[data.orgType] : data.orgType)
  },
  ...getTableColumns(PartColumns),
  {
    name: 'esysStatus',
    type: 'object',
    label: 'Status',
    filterable: true,
    optionList: [
      { label: 'Active', value: 'Active' },
      { label: 'Inactive', value: 'Inactive' }
    ]
  },
  {
    name: 'hasRestrictions',
    type: 'object',
    label: 'Has Restriction(s)',
    filterable: true,
    align: 'center',
    optionList: [
      { label: 'Yes', value: true },
      { label: 'No', value: false }
    ],
    renderCell: data => (
      <BoolToString
        boolValue={data.hasRestrictions}
      />
    )
  }
];


export default ParticipationColumns;
